import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-lg-6 mb-4" }
const _hoisted_2 = { class: "card h-100" }
const _hoisted_3 = { class: "card-body d-flex flex-column justify-content-between" }
const _hoisted_4 = { class: "card-title mb-3 fw-bold" }
const _hoisted_5 = { class: "small" }
const _hoisted_6 = { class: "fw-bold text-uppercase" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "VER MAS", -1)


import BaseImg from './BaseImg.vue'
import { RouterLink } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'VCardImageWithText',
  props: {
    id: null,
    imagen: null,
    titulo: null,
    subtitlo: null,
    texto: null
  },
  setup(__props: any) {

const props = __props as {
  id: number
  imagen: string
  titulo: string
  subtitlo?: string
  texto?: string
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseImg, {
        src: props.imagen,
        alt: props.titulo
      }, null, 8, ["src", "alt"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(props.subtitlo), 1),
          _createElementVNode("h4", _hoisted_6, _toDisplayString(props.titulo), 1)
        ]),
        _createVNode(_unref(RouterLink), {
          to: { name: 'Actividad', params: { actividadId: props.id } },
          class: "btn btn-primary mt-3 align-self-start"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})